import React from 'react';
import { TouchableOpacity, Text, StyleSheet, ActivityIndicator, Platform } from 'react-native';
import { Paprika } from '../../styles/theme';
import { GoogleG } from './authGraphics';

interface GoogleButtonProps {
  label: string;
  onPress: () => void;
  disabled?: boolean;
  loading?: boolean;
}

/**
 * Outlined white OAuth pill with the real multicolor Google mark. `label` is a
 * prop so error states can relabel it to "Réessayer avec Google".
 */
export const GoogleButton: React.FC<GoogleButtonProps> = ({ label, onPress, disabled, loading }) => (
  <TouchableOpacity
    onPress={onPress}
    disabled={disabled || loading}
    activeOpacity={0.75}
    style={styles.button}
  >
    {loading ? (
      <ActivityIndicator color={Paprika.textPrimary} />
    ) : (
      <>
        <GoogleG size={18} />
        <Text style={styles.label}>{label}</Text>
      </>
    )}
  </TouchableOpacity>
);

const styles = StyleSheet.create({
  button: {
    width: '100%',
    height: 52,
    borderRadius: 999,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    backgroundColor: Paprika.cardBg,
    borderWidth: 1,
    borderColor: Paprika.border,
    ...Platform.select({
      ios: {
        shadowColor: 'rgba(82,68,60,1)',
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.05,
        shadowRadius: 2,
      },
      android: { elevation: 1 },
      default: { boxShadow: '0 1px 2px rgba(82,68,60,0.05)' },
    }),
  },
  label: {
    fontFamily: 'Inter-Medium',
    fontSize: 15,
    color: Paprika.textPrimary,
  },
});
